import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { MyCardFragment } from 'generated/resources/graphql'

import { useHover } from 'modules/core/lib/hoverContext'
import i18n from 'modules/core/lib/i18n'

import { CardStatusTag } from 'modules/banking/components/CardStatusTag'
import { cardLimitPeriodText } from 'modules/banking/lib/cards/cardLimitPeriodText'
import { cardLogoColor } from 'modules/banking/lib/cards/cardLogoColor'
import { last4digits } from 'modules/banking/lib/cards/last4digits'
import { miniatureColor } from 'modules/banking/lib/cards/miniatureColor'
import { cardShortTypeLabel } from 'modules/banking/lib/cards/shortTypeLabel'

import { RemainingThisMonth } from './RemainigThisMonth'

const CardBox = ({ card }: { card: MyCardFragment }) => {
  const hover = useHover()
  const last4 = last4digits(card)
  const alias = card.alias || i18n.t('expenses_v2.cards.details.factorial_card')
  const last4text = `${cardShortTypeLabel(card)} ${last4}`
  const remainingAmountText = cardLimitPeriodText(card)

  return (
    <Box background={hover ? 'grey100' : 'grey000White'} width="full" height="s140">
      <Box flexDirection="column" justifyContent="spaceBetween" height="full">
        <Box flexDirection="row" gap="s16">
          <CardMiniature card={card} />
          <Box flexDirection="column">
            <Text.Normal capitalize color="grey1000" weight="medium" size="300">
              {alias}
            </Text.Normal>
            <Text.Normal color="grey600" weight="medium" size="200">
              {last4text}
            </Text.Normal>
          </Box>
        </Box>
        <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
          <Box flexDirection="row" alignItems="center" gap="s4">
            <RemainingThisMonth card={card} />
            {card.creationSource != 'salary' && (
              <Text.Normal color="grey600" weight="medium" size="200">
                {remainingAmountText}
              </Text.Normal>
            )}
          </Box>
          <CardStatusTag card={card} />
        </Box>
      </Box>
    </Box>
  )
}

const CardMiniature = ({ card }: { card: MyCardFragment }) => {
  const color = miniatureColor(card)
  const textColor = cardLogoColor(card)

  return (
    <Box
      boxShadow="s400"
      background={color}
      flexDirection="columnReverse"
      borderRadius={{ all: 'abs006' }}
      padding="s6"
      style={{ width: '74px', height: '50px' }}
    >
      <Box flexDirection="rowReverse">
        <Icon.Medium color={textColor} icon="logo-avatar"></Icon.Medium>
      </Box>
    </Box>
  )
}

export default CardBox
